import * as $ajax from './_ajax'
import * as $helpers from './_helpers'
import * as $modal from './_modal'
import * as $msg from './_msg'
import * as $blogpostpopup from './blog.blogpostpopup'

export interface IInitOptions {
    pageName: string
    pagePrefix: string
    accountId: string
}

var options: IInitOptions

export function init($options: any): void {
    options = $options

    elem('name').each((_, tb) => {
        $helpers.onEnter($(tb), function (tb: JQuery) {
            tb.trigger('blur')
        })
    })

    elem('name').on('blur', function () {
        saveName($(this))
    })

    elem('icon-accounts').on('click', function () {
        const id = $(this).attr('data-id')
        $modal.load('/Account/AccountDepartmentsEditDepartment', { id }, false, true, false)
    })

    elem('btn-delete').on('click', function () {
        console.log('kleek')
        if (!confirm('Är du säker på att du vill radera denna avdelning?')) return

        const id = $(this).attr('data-id')
        console.log('delete ' + id)

        $ajax.post({
            loadingText: 'Raderar...',
            url: '/Account/AccountDepartmentsDelete',
            data: {
                id,
            },
            success: function (res: any) {
                if (res.Ok) {
                    $msg.show(`Avdelningen raderad!`)
                    elem('row-' + id).remove()
                } else {
                    $msg.showError(res.Message)
                }
            },
        })
    })

    elem('btn-create').on('click', function () {
        var name = prompt('Ange namn på avdelningen:')

        $ajax.post({
            loadingText: 'Skapar...',
            url: '/Account/AccountDepartmentsCreate',
            data: {
                name,
            },
            success: function (res: any) {
                if (res.Ok) {
                    $msg.show(`Avdelning "${name}" skapad!`)
                    location.reload()
                } else {
                    $msg.showError(res.Message)
                }
            },
        })
    })

    $blogpostpopup.load(9)
}

function saveName(tb: JQuery) {
    const id = tb.attr('data-id')
    const name = tb.val()

    $ajax.post({
        loadingText: 'Sparar...',
        url: '/Account/AccountDepartmentsSave',
        data: {
            id,
            name,
        },
        success: function (res: any) {
            if (res.Ok) {
                $msg.show(`Avdelning "${name}" sparad!`)
            } else {
                $msg.showError(res.Message)
            }
        },
    })
}

function elem(suffix: string): JQuery {
    return $('.' + options.pagePrefix + '-' + suffix)
}
